"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Colors = _interopRequireDefault(require("../../Basic/Colors/Colors"));

require("./Icon.css");

var _excluded = ["icon", "color", "margin", "size", "width", "height"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @visibleName Icons
 */
function Icon(_ref) {
  var icon = _ref.icon,
      color = _ref.color,
      margin = _ref.margin,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, _excluded);

  var classNames = 'icon';
  var styles = {
    margin: margin || undefined,
    width: width || size,
    height: height || size
  };

  switch (icon) {
    case 'arrowDown':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6.70711 8.29329C6.31658 7.90277 5.68342 7.90277 5.29289 8.29329C4.90237 8.68381 4.90237 9.31698 5.29289 9.7075L11.2929 15.7075C11.6715 16.0861 12.2811 16.0993 12.6757 15.7375L18.5 9.7075C18.9071 9.33431 18.9346 8.70174 18.5614 8.29462C18.1882 7.8875 17.5557 7.86 17.1486 8.23319L12.0301 13.6163L6.70711 8.29329Z",
        fill: color
      }));

    case 'arrowLeft':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L8.29289 12.7071C7.91432 12.3285 7.90107 11.7189 8.26285 11.3243L14.2929 5.5C14.6661 5.09288 15.2987 5.06538 15.7058 5.43857C16.1129 5.81176 16.1404 6.44433 15.7672 6.85145L10.3841 11.9699L15.7071 17.2929Z",
        fill: color
      }));

    case 'arrowRight':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.29289 17.2929C7.90237 17.6834 7.90237 18.3166 8.29289 18.7071C8.68342 19.0976 9.31658 19.0976 9.70711 18.7071L15.7071 12.7071C16.0857 12.3285 16.0989 11.7189 15.7372 11.3243L9.70711 5.5C9.33391 5.09288 8.70135 5.06538 8.29423 5.43857C7.88711 5.81176 7.8596 6.44433 8.2328 6.85145L13.6159 11.9699L8.29289 17.2929Z",
        fill: color
      }));

    case 'arrowUp':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.1171 15.6775C17.5076 16.068 18.1408 16.068 18.5313 15.6775C18.9218 15.287 18.9218 14.6538 18.5313 14.2633L12.5313 8.26326C12.1527 7.88468 11.5432 7.87144 11.1485 8.23321L5.32422 14.2633C4.9171 14.6365 4.8896 15.269 5.26279 15.6761C5.63598 16.0833 6.26855 16.1108 6.67567 15.7376L11.7941 10.3545L17.1171 15.6775Z",
        fill: color
      }));

    case 'arrowUpRight':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16.5958 9.31804C16.9863 8.92751 16.9863 8.29435 16.5958 7.90382C16.2053 7.5133 15.5721 7.5133 15.1816 7.90382L6.69628 16.3891C6.30576 16.7796 6.30576 17.4128 6.69628 17.8033C7.08681 18.1938 7.71997 18.1938 8.1105 17.8033L16.5958 9.31804Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.11035 8.90381C7.55807 8.90381 7.11035 8.45609 7.11035 7.90381C7.11035 7.35152 7.55807 6.90381 8.11035 6.90381L16.5956 6.90381C17.131 6.90381 17.5714 7.32549 17.5947 7.86037L17.9482 15.9921C17.9722 16.5439 17.5444 17.0106 16.9926 17.0346C16.4409 17.0586 15.9741 16.6307 15.9501 16.079L15.6382 8.90381H8.11035Z",
        fill: color
      }));

    case 'bell':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: color,
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
      }));

    case 'calendar':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 5C14 6.10457 14.8954 7 16 7C17.1046 7 18 6.10457 18 5V3H19.5C20.3284 3 21 3.67157 21 4.5V19.5C21 20.3284 20.3284 21 19.5 21H4.5C3.67157 21 3 20.3284 3 19.5V4.5C3 3.67157 3.67157 3 4.5 3H6V5C6 6.10457 6.89543 7 8 7C9.10457 7 10 6.10457 10 5V3H14V5ZM6.5 9C5.67157 9 5 9.67157 5 10.5V17.5C5 18.3284 5.67157 19 6.5 19H17.5C18.3284 19 19 18.3284 19 17.5V10.5C19 9.67157 18.3284 9 17.5 9H6.5Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: "7",
        y: "11",
        width: "2",
        height: "2",
        rx: "1",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: "11",
        y: "11",
        width: "2",
        height: "2",
        rx: "1",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: "15",
        y: "11",
        width: "2",
        height: "2",
        rx: "1",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: "7",
        y: "15",
        width: "2",
        height: "2",
        rx: "1",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: "11",
        y: "15",
        width: "2",
        height: "2",
        rx: "1",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: "15",
        y: "15",
        width: "2",
        height: "2",
        rx: "1",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: "15",
        y: "6",
        width: "5",
        height: "2",
        rx: "1",
        transform: "rotate(-90 15 6)",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: "7",
        y: "6",
        width: "5",
        height: "2",
        rx: "1",
        transform: "rotate(-90 7 6)",
        fill: color
      }));

    case 'close':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.287 7.38108L7.55247 15.1156C7.24735 15.4207 7.24735 15.9154 7.55247 16.2205C7.85758 16.5256 8.35228 16.5256 8.6574 16.2205L16.3919 8.48601C16.697 8.18089 16.697 7.6862 16.3919 7.38108C16.0868 7.07596 15.5921 7.07596 15.287 7.38108Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16.3915 15.1156L8.65696 7.38108C8.35184 7.07596 7.85714 7.07596 7.55203 7.38108C7.24691 7.6862 7.24691 8.18089 7.55203 8.48601L15.2865 16.2205C15.5917 16.5256 16.0864 16.5256 16.3915 16.2205C16.6966 15.9154 16.6966 15.4207 16.3915 15.1156Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10",
        stroke: color,
        strokeWidth: "2"
      }));

    case 'delete':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6 7V19.5C6 20.3284 6.67157 21 7.5 21H16.5C17.3284 21 18 20.3284 18 19.5V7H6Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 3.5V3C14 2.44772 13.5523 2 13 2H11C10.4477 2 10 2.44772 10 3V3.5H5.5C5.22386 3.5 5 3.72386 5 4V4.5C5 4.77614 5.22386 5 5.5 5H18.5C18.7761 5 19 4.77614 19 4.5V4C19 3.72386 18.7761 3.5 18.5 3.5H14Z",
        fill: color
      }));

    case 'downLeft':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M7.40422 14.682C7.0137 15.0725 7.0137 15.7057 7.40422 16.0962C7.79475 16.4867 8.42791 16.4867 8.81843 16.0962L17.3037 7.6109C17.6942 7.22037 17.6942 6.58721 17.3037 6.19668C16.9132 5.80616 16.28 5.80616 15.8895 6.19668L7.40422 14.682Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.8896 15.0962C16.4419 15.0962 16.8896 15.5439 16.8896 16.0962C16.8896 16.6485 16.4419 17.0962 15.8896 17.0962H7.40437C6.86898 17.0962 6.42857 16.6745 6.40531 16.1396L6.05176 8.0079C6.02777 7.45614 6.45561 6.9894 7.00738 6.96541C7.55914 6.94142 8.02588 7.36926 8.04987 7.92103L8.36183 15.0962H15.8896Z",
        fill: color
      }));

    case 'downloadFile':
      var arrowColor = color === 'white' ? _Colors.default.withOpacity(_Colors.default.vagaVesi, 0.3) : 'white';
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M5.85714 2H13.7364C14.0911 2 14.4343 2.12568 14.7051 2.35474L19.4687 6.38394C19.8057 6.66895 20 7.08788 20 7.5292V20.0833C20 21.8739 19.9796 22 18.1429 22H5.85714C4.02045 22 4 21.8739 4 20.0833V3.91667C4 2.12612 4.02045 2 5.85714 2Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.2687 12.6538C15.5438 12.3288 15.3128 11.8307 14.8871 11.8307H12.9306V9.82301C12.9306 9.54687 12.7067 9.32301 12.4306 9.32301H11.4073C11.1311 9.32301 10.9073 9.54687 10.9073 9.82301V11.8307L8.95081 11.8307C8.52506 11.8307 8.29411 12.3288 8.56922 12.6538L11.5373 16.1594C11.7371 16.3953 12.1008 16.3953 12.3005 16.1594L15.2687 12.6538Z",
        fill: arrowColor
      }));

    case 'earth':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        opacity: "0.3",
        d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.7358 20.9962C6.8874 20.8564 3 16.8822 3 12C3 11.9168 3.00113 11.8339 3.00337 11.7513C3.66233 11.8143 4.85637 11.9574 4.91263 12.4204C4.99049 13.0609 4.91263 13.8616 5.45805 14.1018C6.00346 14.342 6.15932 13.1409 6.62675 13.4613C7.09418 13.7816 8.34087 14.0899 8.34087 14.6562C8.34087 15.2224 8.10715 16.1035 8.34087 16.2636C8.57458 16.4238 9.50897 17.5446 9.50921 17.7048C9.50957 17.865 9.83857 18.6794 9.7404 18.9907C9.65905 19.2487 9.24858 20.0502 8.8506 20.4146C9.75315 20.7621 10.7236 20.9658 11.7358 20.9961V20.9962ZM8.28273 3.80112C9.41584 3.28656 10.6745 3 12 3C15.5115 3 18.5532 5.01097 20.0364 7.94408C20.0697 8.72412 20.0638 9.39135 20.2361 9.63274C21.1132 10.8601 18.0995 11.7043 18.5573 13.5605C18.759 14.3795 16.5528 14.1197 16.014 14.8864C15.4748 15.6527 14.1575 15.1378 13.852 14.9905C13.5466 14.8432 12.3766 15.3341 12.4789 14.4995C12.5806 13.6646 13.2923 13.6156 14.0556 13.272C14.8185 12.9287 15.9189 11.7872 15.3782 11.638C12.8323 10.9362 11.9638 8.47852 11.9638 8.47852C11.811 8.44901 11.8494 6.74109 11.1884 6.69207C10.5267 6.6428 10.1705 6.88841 9.20436 6.69207C8.23765 6.49573 8.44144 5.85744 8.28872 4.48256C8.25454 4.17416 8.25619 3.95717 8.28273 3.80112ZM20.9992 11.877C20.9997 11.918 21 11.9589 21 12C21 16.9407 17.0188 20.9515 12.0895 20.9996C16.9702 20.9503 20.9337 16.8884 20.9992 11.877Z",
        fill: color
      }));

    case 'edit':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M19.2536 5.89982C19.831 6.47722 19.8405 7.41042 19.2749 7.99942L11.6518 15.938C11.3765 16.2247 10.9987 16.3904 10.6014 16.3987L7.39538 16.466L7.46296 13.2448C7.47111 12.8564 7.62958 12.4864 7.90502 12.2125L15.7003 4.46178C16.2866 3.87885 17.234 3.88021 17.8186 4.46481L19.2536 5.89982Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        opacity: "0.3",
        d: "M12.81 3C13.3071 3 13.71 3.40294 13.71 3.9C13.71 4.39706 13.3071 4.8 12.81 4.8H6.6C5.60589 4.8 4.8 5.60589 4.8 6.6V17.4C4.8 18.3941 5.60589 19.2 6.6 19.2H17.4C18.3941 19.2 19.2 18.3941 19.2 17.4V12.9C19.2 12.4029 19.6029 12 20.1 12C20.5971 12 21 12.4029 21 12.9V17.4C21 19.3882 19.3882 21 17.4 21H6.6C4.61177 21 3 19.3882 3 17.4V6.6C3 4.61177 4.61177 3 6.6 3H12.81Z",
        fill: color
      }));

    case 'filePlus':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M5.85714 2H13.7364C14.0911 2 14.4343 2.12568 14.7051 2.35474L19.4687 6.38394C19.8057 6.66895 20 7.08788 20 7.5292V20.0833C20 21.8739 19.9796 22 18.1429 22H5.85714C4.02045 22 4 21.8739 4 20.0833V3.91667C4 2.12612 4.02045 2 5.85714 2Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.0002 14L9.00015 14C8.44787 14 8.00015 13.5523 8.00015 13C8.00015 12.4477 8.44787 12 9.00015 12L11.0002 12L11.0002 10C11.0002 9.44772 11.4479 9 12.0002 9C12.5524 9 13.0002 9.44772 13.0002 10L13.0002 12H15.0002C15.5524 12 16.0002 12.4477 16.0002 13C16.0002 13.5523 15.5524 14 15.0002 14H13.0002L13.0002 16C13.0002 16.5523 12.5524 17 12.0002 17C11.4479 17 11.0002 16.5523 11.0002 16L11.0002 14Z",
        fill: "white"
      }));

    case 'files':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M5.85714 2.00009H13.7364C14.0911 2.00009 14.4343 2.12578 14.7051 2.35483L19.4687 6.38403C19.8057 6.66904 20 7.08797 20 7.52929V20.0834C20 21.874 19.9796 22.0001 18.1429 22.0001H5.85714C4.02045 22.0001 4 21.874 4 20.0834V3.91676C4 2.12622 4.02045 2.00009 5.85714 2.00009Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.001 11.0001H7.00098C6.44869 11.0001 6.00098 11.4478 6.00098 12.0001C6.00098 12.5524 6.44869 13.0001 7.00098 13.0001H14.001C14.5533 13.0001 15.001 12.5524 15.001 12.0001C15.001 11.4478 14.5533 11.0001 14.001 11.0001Z",
        fill: "white"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10.001 15H7.00098C6.44869 15 6.00098 15.4477 6.00098 16C6.00098 16.5523 6.44869 17 7.00098 17H10.001C10.5533 17 11.001 16.5523 11.001 16C11.001 15.4477 10.5533 15 10.001 15Z",
        fill: "white"
      }));

    case 'filters':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        opacity: "0.3",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.5 7C3.67157 7 3 7.67157 3 8.5C3 9.32843 3.67157 10 4.5 10H9.5C10.3284 10 11 9.32843 11 8.5C11 7.67157 10.3284 7 9.5 7H4.5ZM13.5 15C12.6716 15 12 15.6716 12 16.5C12 17.3284 12.6716 18 13.5 18H18.5C19.3284 18 20 17.3284 20 16.5C20 15.6716 19.3284 15 18.5 15H13.5Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 8C20 9.65685 18.6569 11 17 11C15.3431 11 14 9.65685 14 8C14 6.34315 15.3431 5 17 5C18.6569 5 20 6.34315 20 8ZM9 16C9 17.6569 7.65685 19 6 19C4.34315 19 3 17.6569 3 16C3 14.3431 4.34315 13 6 13C7.65685 13 9 14.3431 9 16Z",
        fill: color
      }));

    case 'inProgress':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.8002 12C22.8002 17.9647 17.9649 22.8 12.0002 22.8C6.03552 22.8 1.2002 17.9647 1.2002 12C1.2002 6.03534 6.03552 1.20001 12.0002 1.20001C17.9649 1.20001 22.8002 6.03534 22.8002 12ZM21.0002 12C21.0002 16.9706 16.9708 21 12.0002 21C7.02963 21 3.0002 16.9706 3.0002 12C3.0002 7.02945 7.02963 3.00001 12.0002 3.00001C16.9708 3.00001 21.0002 7.02945 21.0002 12Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.9141 7C11.4189 7 11.8282 7.39409 11.8282 7.88021L11.8279 13.3735L15 15C15.4415 15.2357 15.6011 15.7714 15.3563 16.1966C15.1116 16.6218 14.5552 16.7754 14.1137 16.5397L10.6711 14.7707C10.2842 14.6682 10 14.327 10 13.9219V7.88021C10 7.39409 10.4092 7 10.9141 7Z",
        fill: color
      }));

    case 'layers':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        id: "layers-icon",
        className: classNames,
        style: styles,
        xmlns: "http://www.w3.org/2000/svg"
      }, rest, {
        width: "24",
        height: "20",
        viewBox: "0 0 24 20",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M0 3.6594C0 3.25937 0.238397 2.89783 0.606081 2.74025L5.60608 0.597394C6.26595 0.314594 7 0.798623 7 1.51654V16.3406C7 16.7406 6.7616 17.1022 6.39392 17.2597L1.39392 19.4026C0.734052 19.6854 0 19.2014 0 18.4835V3.6594Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 3.6594C17 3.25937 17.2384 2.89783 17.6061 2.74025L22.6061 0.597394C23.2659 0.314594 24 0.798623 24 1.51654V16.3406C24 16.7406 23.7616 17.1022 23.3939 17.2597L18.3939 19.4026C17.7341 19.6854 17 19.2014 17 18.4835V3.6594Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8 16.307C8 16.7238 8.25857 17.097 8.64888 17.2433L14.6489 19.4933C15.3026 19.7385 16 19.2552 16 18.557V3.693C16 3.27616 15.7414 2.90304 15.3511 2.75667L9.35112 0.506672C8.69737 0.261515 8 0.744795 8 1.443V16.307Z",
        fill: color
      }));

    case 'loading':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        id: "loading-icon",
        className: classNames,
        style: styles,
        xmlns: "http://www.w3.org/2000/svg"
      }, rest, {
        width: "24",
        height: "24",
        viewBox: "0 0 50 50",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("circle", {
        fill: "none",
        stroke: color,
        strokeOpacity: ".4",
        strokeWidth: "4",
        cx: "25.1",
        cy: "25.1",
        r: "17.2"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M43.9 25.1c0-10.3-8.4-18.7-18.7-18.7 -10.3 0-18.7 8.4-18.7 18.7h4.1c0-8.1 6.5-14.6 14.6-14.6 8.1 0 14.6 6.5 14.6 14.6H43.9z"
      }, /*#__PURE__*/_react.default.createElement("animateTransform", {
        attributeType: "xml",
        attributeName: "transform",
        type: "rotate",
        from: "0 25 25",
        to: "360 25 25",
        dur: "0.8s",
        repeatCount: "indefinite"
      })));

    case 'map':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M5 10.5C5 6 8 3 12.5 3C17 3 20 6.75 20 10.5C20 12.8326 17.8237 16.0357 13.471 20.1093C12.9154 20.6293 12.0585 20.6508 11.4775 20.1595C7.15915 16.5078 5 13.288 5 10.5ZM12.5 12C13.8807 12 15 10.8807 15 9.5C15 8.11929 13.8807 7 12.5 7C11.1193 7 10 8.11929 10 9.5C10 10.8807 11.1193 12 12.5 12Z",
        fill: color
      }));

    case 'menu':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M19 17H5M19 12H5H19ZM19 7H5H19Z",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case 'minus':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: "6",
        y: "11",
        width: "12",
        height: "2",
        rx: "1",
        fill: "white"
      }));

    case 'notification':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("g", {
        clipPath: "url(#clip0)"
      }, /*#__PURE__*/_react.default.createElement("g", {
        filter: "url(#filter0_d)"
      }, /*#__PURE__*/_react.default.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10",
        stroke: color,
        strokeWidth: "2"
      })), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: "11",
        y: "6",
        width: "2",
        height: "9",
        rx: "1",
        fill: color
      })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("filter", {
        id: "filter0_d",
        x: "-4",
        y: "-2",
        width: "32",
        height: "32",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
      }, /*#__PURE__*/_react.default.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      }), /*#__PURE__*/_react.default.createElement("feOffset", {
        dy: "2"
      }), /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
        stdDeviation: "2.5"
      }), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
      }), /*#__PURE__*/_react.default.createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow"
      }), /*#__PURE__*/_react.default.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow",
        result: "shape"
      })), /*#__PURE__*/_react.default.createElement("clipPath", {
        id: "clip0"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
      }))));

    case 'pencil':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M19.9244 6.31811C20.5102 6.90389 20.5102 7.85364 19.9244 8.43943L11.4759 16.8879C11.191 17.1728 10.8034 17.3311 10.4005 17.3272L6.87715 17.2925C6.06913 17.2846 5.41263 16.638 5.39237 15.8302L5.30643 12.4031C5.29613 11.9923 5.45477 11.5953 5.7453 11.3048L14.2675 2.78257C14.8533 2.19678 15.8031 2.19679 16.3888 2.78257L19.9244 6.31811Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("rect", {
        opacity: "0.3",
        x: "5",
        y: "20",
        width: "15",
        height: "2",
        rx: "1",
        fill: color
      }));

    case 'plus':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7V11H7C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H11V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H13V7Z",
        fill: "white"
      }));

    case 'position':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        opacity: "0.3",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 3C11 2.44772 11.4477 2 12 2C12.5523 2 13 2.44772 13 3V5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5V3ZM3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H5C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11H3ZM19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H19ZM12 18C11.4477 18 11 18.4477 11 19V21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21V19C13 18.4477 12.5523 18 12 18Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        opacity: "0.3",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12ZM17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z",
        fill: color
      }));

    case 'register':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12.2109 13.2109H10.3438V17.375H8V6H12.2266C13.5703 6 14.6068 6.29948 15.3359 6.89844C16.0651 7.4974 16.4297 8.34375 16.4297 9.4375C16.4297 10.2135 16.2604 10.862 15.9219 11.3828C15.5885 11.8984 15.0807 12.3099 14.3984 12.6172L16.8594 17.2656V17.375H14.3438L12.2109 13.2109ZM10.3438 11.3125H12.2344C12.8229 11.3125 13.2786 11.1641 13.6016 10.8672C13.9245 10.5651 14.0859 10.151 14.0859 9.625C14.0859 9.08854 13.9323 8.66667 13.625 8.35938C13.3229 8.05208 12.8568 7.89844 12.2266 7.89844H10.3438V11.3125Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "2",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case 'renewed':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("mask", {
        id: "path-1-outside-1",
        maskUnits: "userSpaceOnUse",
        x: "1",
        y: "1",
        width: "20",
        height: "16",
        fill: "black"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        fill: "white",
        x: "1",
        y: "1",
        width: "20",
        height: "16"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M2.58697 15.3611C2.64807 15.524 2.80286 15.6299 2.96579 15.6299C3.0106 15.6299 3.0554 15.6218 3.10021 15.6055C3.30795 15.5322 3.41793 15.3 3.34461 15.0882C2.15113 11.7521 2.94542 8.1065 5.422 5.57289C7.1328 3.82136 9.42608 2.83969 11.8741 2.81118C14.3181 2.78267 16.6359 3.70731 18.3874 5.41811L17.3568 5.43033C17.1328 5.4344 16.9576 5.61362 16.9576 5.83766C16.9617 6.05762 17.1409 6.23684 17.3609 6.23684H17.365L19.369 6.2124C19.475 6.2124 19.5768 6.1676 19.6542 6.0902C19.7275 6.01281 19.7682 5.91098 19.7682 5.80507L19.7438 3.801C19.7397 3.57696 19.5605 3.39367 19.3365 3.40181C19.1124 3.40589 18.9373 3.58511 18.9373 3.80914L18.9495 4.83969C17.0432 2.97819 14.5299 1.97208 11.866 2.00059C9.20204 2.03725 6.7051 3.10039 4.84359 5.0067C3.51162 6.37126 2.59919 8.07798 2.21223 9.93542C1.83341 11.748 1.96375 13.6218 2.58697 15.3611Z"
      })), /*#__PURE__*/_react.default.createElement("path", {
        d: "M2.58697 15.3611C2.64807 15.524 2.80286 15.6299 2.96579 15.6299C3.0106 15.6299 3.0554 15.6218 3.10021 15.6055C3.30795 15.5322 3.41793 15.3 3.34461 15.0882C2.15113 11.7521 2.94542 8.1065 5.422 5.57289C7.1328 3.82136 9.42608 2.83969 11.8741 2.81118C14.3181 2.78267 16.6359 3.70731 18.3874 5.41811L17.3568 5.43033C17.1328 5.4344 16.9576 5.61362 16.9576 5.83766C16.9617 6.05762 17.1409 6.23684 17.3609 6.23684H17.365L19.369 6.2124C19.475 6.2124 19.5768 6.1676 19.6542 6.0902C19.7275 6.01281 19.7682 5.91098 19.7682 5.80507L19.7438 3.801C19.7397 3.57696 19.5605 3.39367 19.3365 3.40181C19.1124 3.40589 18.9373 3.58511 18.9373 3.80914L18.9495 4.83969C17.0432 2.97819 14.5299 1.97208 11.866 2.00059C9.20204 2.03725 6.7051 3.10039 4.84359 5.0067C3.51162 6.37126 2.59919 8.07798 2.21223 9.93542C1.83341 11.748 1.96375 13.6218 2.58697 15.3611Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M2.58697 15.3611C2.64807 15.524 2.80286 15.6299 2.96579 15.6299C3.0106 15.6299 3.0554 15.6218 3.10021 15.6055C3.30795 15.5322 3.41793 15.3 3.34461 15.0882C2.15113 11.7521 2.94542 8.1065 5.422 5.57289C7.1328 3.82136 9.42608 2.83969 11.8741 2.81118C14.3181 2.78267 16.6359 3.70731 18.3874 5.41811L17.3568 5.43033C17.1328 5.4344 16.9576 5.61362 16.9576 5.83766C16.9617 6.05762 17.1409 6.23684 17.3609 6.23684H17.365L19.369 6.2124C19.475 6.2124 19.5768 6.1676 19.6542 6.0902C19.7275 6.01281 19.7682 5.91098 19.7682 5.80507L19.7438 3.801C19.7397 3.57696 19.5605 3.39367 19.3365 3.40181C19.1124 3.40589 18.9373 3.58511 18.9373 3.80914L18.9495 4.83969C17.0432 2.97819 14.5299 1.97208 11.866 2.00059C9.20204 2.03725 6.7051 3.10039 4.84359 5.0067C3.51162 6.37126 2.59919 8.07798 2.21223 9.93542C1.83341 11.748 1.96375 13.6218 2.58697 15.3611Z",
        stroke: color,
        strokeWidth: "0.8",
        mask: "url(#path-1-outside-1)"
      }), /*#__PURE__*/_react.default.createElement("mask", {
        id: "path-2-outside-2",
        maskUnits: "userSpaceOnUse",
        x: "3.19141",
        y: "7.34448",
        width: "20",
        height: "16",
        fill: "black"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        fill: "white",
        x: "3.19141",
        y: "7.34448",
        width: "20",
        height: "16"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18.5376 18.3917C15.0061 22.0088 9.18937 22.0739 5.57226 18.5464L6.60281 18.5342C6.82684 18.5301 7.002 18.3509 7.002 18.1269C6.99792 17.9069 6.8187 17.7277 6.59874 17.7277L4.59059 17.7521C4.36656 17.7562 4.19141 17.9354 4.19141 18.1595L4.21585 20.1635C4.21992 20.3835 4.39915 20.5627 4.6191 20.5627C4.84721 20.5587 5.02236 20.3794 5.02236 20.1554L5.01014 19.1249C6.94904 21.0149 9.46228 21.9599 11.9796 21.9599C14.5743 21.9599 17.1649 20.9578 19.1161 18.9619C20.448 17.5974 21.3605 15.8906 21.7474 14.0332C22.1262 12.2246 21.9959 10.3468 21.3727 8.61162C21.2993 8.40388 21.0672 8.2939 20.8554 8.36722C20.6476 8.44054 20.5376 8.67271 20.611 8.88453C21.8085 12.2124 21.0142 15.8581 18.5376 18.3917Z"
      })), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18.5376 18.3917C15.0061 22.0088 9.18937 22.0739 5.57226 18.5464L6.60281 18.5342C6.82684 18.5301 7.002 18.3509 7.002 18.1269C6.99792 17.9069 6.8187 17.7277 6.59874 17.7277L4.59059 17.7521C4.36656 17.7562 4.19141 17.9354 4.19141 18.1595L4.21585 20.1635C4.21992 20.3835 4.39915 20.5627 4.6191 20.5627C4.84721 20.5587 5.02236 20.3794 5.02236 20.1554L5.01014 19.1249C6.94904 21.0149 9.46228 21.9599 11.9796 21.9599C14.5743 21.9599 17.1649 20.9578 19.1161 18.9619C20.448 17.5974 21.3605 15.8906 21.7474 14.0332C22.1262 12.2246 21.9959 10.3468 21.3727 8.61162C21.2993 8.40388 21.0672 8.2939 20.8554 8.36722C20.6476 8.44054 20.5376 8.67271 20.611 8.88453C21.8085 12.2124 21.0142 15.8581 18.5376 18.3917Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18.5376 18.3917C15.0061 22.0088 9.18937 22.0739 5.57226 18.5464L6.60281 18.5342C6.82684 18.5301 7.002 18.3509 7.002 18.1269C6.99792 17.9069 6.8187 17.7277 6.59874 17.7277L4.59059 17.7521C4.36656 17.7562 4.19141 17.9354 4.19141 18.1595L4.21585 20.1635C4.21992 20.3835 4.39915 20.5627 4.6191 20.5627C4.84721 20.5587 5.02236 20.3794 5.02236 20.1554L5.01014 19.1249C6.94904 21.0149 9.46228 21.9599 11.9796 21.9599C14.5743 21.9599 17.1649 20.9578 19.1161 18.9619C20.448 17.5974 21.3605 15.8906 21.7474 14.0332C22.1262 12.2246 21.9959 10.3468 21.3727 8.61162C21.2993 8.40388 21.0672 8.2939 20.8554 8.36722C20.6476 8.44054 20.5376 8.67271 20.611 8.88453C21.8085 12.2124 21.0142 15.8581 18.5376 18.3917Z",
        stroke: color,
        strokeWidth: "0.8",
        mask: "url(#path-2-outside-2)"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
        fill: color
      }));

    case 'reset':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.43297 7.17429L9.40782 7.85689C9.49617 7.91875 9.56214 8.00752 9.5959 8.10994C9.68235 8.37221 9.53982 8.65489 9.27756 8.74134L5.8908 9.85769C5.84469 9.87289 5.79662 9.88129 5.74809 9.88263C5.47205 9.89027 5.24209 9.67268 5.23446 9.39665L5.1361 5.83998C5.13313 5.73269 5.16477 5.62729 5.22633 5.53937C5.38472 5.31317 5.6965 5.25819 5.9227 5.41658L6.7291 5.98123C8.16546 4.72182 10.024 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12H6C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C10.6885 6 9.44767 6.42282 8.43297 7.17429Z",
        fill: color
      }));

    case 'ruler':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.10074 14.8284C1.31969 15.6095 1.31969 16.8758 2.10074 17.6569L6.34338 21.8995C7.12443 22.6805 8.39076 22.6805 9.1718 21.8995L21.8997 9.17158C22.6808 8.39053 22.6808 7.1242 21.8997 6.34315L17.6571 2.10051C16.876 1.31946 15.6097 1.31946 14.8287 2.10051L16.95 4.22183C17.3405 4.61235 17.3405 5.24552 16.95 5.63604C16.5595 6.02657 15.9263 6.02657 15.5358 5.63604L13.4144 3.51472L12.0002 4.92894L12.7073 5.63604C13.0979 6.02657 13.0979 6.65973 12.7073 7.05026C12.3168 7.44078 11.6836 7.44078 11.2931 7.05026L10.586 6.34315L9.1718 7.75736L11.2931 9.87868C11.6836 10.2692 11.6836 10.9024 11.2931 11.2929C10.9026 11.6834 10.2694 11.6834 9.87891 11.2929L7.75759 9.17158L6.34338 10.5858L7.05048 11.2929C7.44101 11.6834 7.44101 12.3166 7.05048 12.7071C6.65996 13.0976 6.0268 13.0976 5.63627 12.7071L4.92916 12L3.51495 13.4142L5.63627 15.5355C6.0268 15.9261 6.0268 16.5592 5.63627 16.9498C5.24575 17.3403 4.61258 17.3403 4.22206 16.9498L2.10074 14.8284Z",
        fill: color
      }));

    case 'search':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.70711 16.7071C10.0976 16.3166 10.0976 15.6834 9.70711 15.2929C9.31658 14.9024 8.68342 14.9024 8.29289 15.2929L4.29289 19.2929C3.90237 19.6834 3.90237 20.3166 4.29289 20.7071C4.68342 21.0976 5.31658 21.0976 5.70711 20.7071L9.70711 16.7071Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M13 16C10.2386 16 8 13.7614 8 11C8 8.23858 10.2386 6 13 6C15.7614 6 18 8.23858 18 11C18 13.7614 15.7614 16 13 16ZM13 18C16.866 18 20 14.866 20 11C20 7.13401 16.866 4 13 4C9.13401 4 6 7.13401 6 11C6 14.866 9.13401 18 13 18Z",
        fill: color
      }));

    case 'sort':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        opacity: "0.3",
        d: "M11.4324 6.78652C11.7118 6.39937 12.2882 6.39938 12.5676 6.78652L14.6633 9.69036C14.9974 10.1533 14.6666 10.8 14.0957 10.8H9.90433C9.33341 10.8 9.00261 10.1533 9.33671 9.69036L11.4324 6.78652Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        opacity: "0.3",
        d: "M11.4324 16.4135C11.7118 16.8006 12.2882 16.8006 12.5676 16.4135L14.6633 13.5097C14.9974 13.0467 14.6666 12.4 14.0957 12.4H9.90433C9.33341 12.4 9.00261 13.0467 9.33671 13.5097L11.4324 16.4135Z",
        fill: color
      }));

    case 'sortAsc':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.4324 6.78652C11.7118 6.39937 12.2882 6.39938 12.5676 6.78652L14.6633 9.69036C14.9974 10.1533 14.6666 10.8 14.0957 10.8H9.90433C9.33341 10.8 9.00261 10.1533 9.33671 9.69036L11.4324 6.78652Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        opacity: "0.3",
        d: "M11.4324 16.4135C11.7118 16.8006 12.2882 16.8006 12.5676 16.4135L14.6633 13.5097C14.9974 13.0467 14.6666 12.4 14.0957 12.4H9.90433C9.33341 12.4 9.00261 13.0467 9.33671 13.5097L11.4324 16.4135Z",
        fill: color
      }));

    case 'sortDesc':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        opacity: "0.3",
        d: "M11.4324 6.78652C11.7118 6.39937 12.2882 6.39938 12.5676 6.78652L14.6633 9.69036C14.9974 10.1533 14.6666 10.8 14.0957 10.8H9.90433C9.33341 10.8 9.00261 10.1533 9.33671 9.69036L11.4324 6.78652Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.4324 16.4135C11.7118 16.8006 12.2882 16.8006 12.5676 16.4135L14.6633 13.5097C14.9974 13.0467 14.6666 12.4 14.0957 12.4H9.90433C9.33341 12.4 9.00261 13.0467 9.33671 13.5097L11.4324 16.4135Z",
        fill: color
      }));

    case 'tick':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M4 12.5L9 17.5L19.5 7",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case 'times':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16.2433 6.34314L6.34383 16.2426C5.9533 16.6332 5.9533 17.2663 6.34383 17.6568C6.73435 18.0474 7.36751 18.0474 7.75804 17.6568L17.6575 7.75735C18.0481 7.36682 18.0481 6.73366 17.6575 6.34314C17.267 5.95261 16.6338 5.95261 16.2433 6.34314Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.6574 16.2426L7.75789 6.34315C7.36736 5.95263 6.7342 5.95263 6.34367 6.34315C5.95315 6.73368 5.95315 7.36684 6.34367 7.75737L16.2432 17.6569C16.6337 18.0474 17.2669 18.0474 17.6574 17.6569C18.0479 17.2663 18.0479 16.6332 17.6574 16.2426Z",
        fill: color
      }));

    case 'user':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 11C10.8954 11 10 10.1046 10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9C14 10.1046 13.1046 11 12 11ZM7.00036 16.4995C7.2157 13.5166 9.36773 12 11.9907 12C14.6507 12 16.836 13.4332 16.9988 16.5C17.0053 16.6222 16.9988 17 16.5815 17H7.40417C7.26484 17 6.98863 16.662 7.00036 16.4995Z",
        fill: "white"
      }));

    case 'add':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7V11H7C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H11V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H13V7Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("rect", {
        opacity: "0.1",
        width: "24",
        height: "24",
        rx: "4",
        fill: color
      }));

    case 'drawPoint':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 11.75C5 15.616 8.13401 18.75 12 18.75C15.866 18.75 19 15.616 19 11.75C19 7.88401 15.866 4.75 12 4.75C8.13401 4.75 5 7.88401 5 11.75ZM16.1996 11.7496C16.1996 14.0692 14.3192 15.9496 11.9996 15.9496C9.67998 15.9496 7.79958 14.0692 7.79958 11.7496C7.79958 9.42998 9.67998 7.54958 11.9996 7.54958C14.3192 7.54958 16.1996 9.42998 16.1996 11.7496Z",
        fill: color
      }));

    case 'drawLineString':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 10.5C19.6569 10.5 21 9.15685 21 7.5C21 5.84315 19.6569 4.5 18 4.5C16.3431 4.5 15 5.84315 15 7.5C15 9.15685 16.3431 10.5 18 10.5Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 21C7.65685 21 9 19.6569 9 18C9 16.3431 7.65685 15 6 15C4.34315 15 3 16.3431 3 18C3 19.6569 4.34315 21 6 21Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("rect", {
        opacity: "0.3",
        x: "8.90332",
        y: "14.4395",
        width: "6.87444",
        height: "2",
        rx: "1",
        transform: "rotate(-45 8.90332 14.4395)",
        fill: color
      }));

    case 'drawPolygon':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        opacity: "0.3",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 18.5C8 19.8807 6.88071 21 5.5 21C4.11929 21 3 19.8807 3 18.5C3 17.1193 4.11929 16 5.5 16C6.88071 16 8 17.1193 8 18.5ZM21 18.5C21 19.8807 19.8807 21 18.5 21C17.1193 21 16 19.8807 16 18.5C16 17.1193 17.1193 16 18.5 16C19.8807 16 21 17.1193 21 18.5Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.1048 8.72344C17.5668 8.42089 17.6961 7.80107 17.3936 7.33902C17.091 6.87698 16.4712 6.74768 16.0092 7.05023L14.336 8.14585C13.8739 8.4484 13.7446 9.06822 14.0472 9.53026C14.3497 9.99231 14.9696 10.1216 15.4316 9.81906L17.1048 8.72344ZM6.54732 7.3402C6.24477 7.80224 6.37407 8.42206 6.83611 8.72461L8.50932 9.82023C8.97136 10.1228 9.59119 9.99348 9.89373 9.53144C10.1963 9.0694 10.067 8.44957 9.60494 8.14703L7.93173 7.05141C7.46969 6.74886 6.84987 6.87816 6.54732 7.3402ZM2.88886 11.4793C2.77503 10.9389 3.12085 10.4085 3.66128 10.2947C4.20171 10.1808 4.73209 10.5266 4.84592 11.0671L5.25814 13.0241C5.37197 13.5646 5.02615 14.0949 4.48572 14.2088C3.9453 14.3226 3.41491 13.9768 3.30108 13.4364L2.88886 11.4793ZM9.99976 19.0003C9.99976 18.448 10.4475 18.0003 10.9998 18.0003H12.9998C13.552 18.0003 13.9998 18.448 13.9998 19.0003C13.9998 19.5526 13.552 20.0003 12.9998 20.0003H10.9998C10.4475 20.0003 9.99976 19.5526 9.99976 19.0003ZM20.4152 10.2086C19.8749 10.0937 19.3439 10.4386 19.2291 10.9788L18.8133 12.9351C18.6984 13.4753 19.0433 14.0063 19.5835 14.1212C20.1237 14.236 20.6547 13.8911 20.7696 13.3509L21.1854 11.3946C21.3002 10.8544 20.9554 10.3234 20.4152 10.2086Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.5 8C3.88071 8 5 6.88071 5 5.5C5 4.11929 3.88071 3 2.5 3C1.11929 3 0 4.11929 0 5.5C0 6.88071 1.11929 8 2.5 8Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 15.5C13.3807 15.5 14.5 14.3807 14.5 13C14.5 11.6193 13.3807 10.5 12 10.5C10.6193 10.5 9.5 11.6193 9.5 13C9.5 14.3807 10.6193 15.5 12 15.5Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.5 8C22.8807 8 24 6.88071 24 5.5C24 4.11929 22.8807 3 21.5 3C20.1193 3 19 4.11929 19 5.5C19 6.88071 20.1193 8 21.5 8Z",
        fill: color
      }));

    case 'modify':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        opacity: "0.3",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.5 8C19.8807 8 21 6.88071 21 5.5C21 4.11929 19.8807 3 18.5 3C17.1193 3 16 4.11929 16 5.5C16 6.88071 17.1193 8 18.5 8ZM18.5 21C19.8807 21 21 19.8807 21 18.5C21 17.1193 19.8807 16 18.5 16C17.1193 16 16 17.1193 16 18.5C16 19.8807 17.1193 21 18.5 21ZM8 18.5C8 19.8807 6.88071 21 5.5 21C4.11929 21 3 19.8807 3 18.5C3 17.1193 4.11929 16 5.5 16C6.88071 16 8 17.1193 8 18.5Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 8C6.88071 8 8 6.88071 8 5.5C8 4.11929 6.88071 3 5.5 3C4.11929 3 3 4.11929 3 5.5C3 6.88071 4.11929 8 5.5 8ZM10 5C10 4.44772 10.4477 4 11 4H13C13.5523 4 14 4.44772 14 5C14 5.55228 13.5523 6 13 6H11C10.4477 6 10 5.55228 10 5ZM11 18C10.4477 18 10 18.4477 10 19C10 19.5523 10.4477 20 11 20H13C13.5523 20 14 19.5523 14 19C14 18.4477 13.5523 18 13 18H11ZM4 11C4 10.4477 4.44772 10 5 10C5.55228 10 6 10.4477 6 11V13C6 13.5523 5.55228 14 5 14C4.44772 14 4 13.5523 4 13V11ZM19 10C18.4477 10 18 10.4477 18 11V13C18 13.5523 18.4477 14 19 14C19.5523 14 20 13.5523 20 13V11C20 10.4477 19.5523 10 19 10Z",
        fill: color
      }));

    case 'drag':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.76609 11.0143C3.2138 11.0143 2.76609 11.462 2.76609 12.0143C2.76609 12.5666 3.2138 13.0143 3.76609 13.0143L11.008 13.0143L11.008 21.7637C11.008 22.3159 11.4557 22.7637 12.008 22.7637C12.5603 22.7637 13.008 22.3159 13.008 21.7637V13.0143L21.7661 13.0143C22.3184 13.0143 22.7661 12.5666 22.7661 12.0143C22.7661 11.462 22.3184 11.0143 21.7661 11.0143L13.008 11.0143L13.008 3.76365C13.008 3.21137 12.5603 2.76365 12.008 2.76365C11.4557 2.76365 11.008 3.21137 11.008 3.76366L11.008 11.0143L3.76609 11.0143Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.90122 5.62944L12.0225 3.50812L14.1439 5.62944C14.1439 5.62944 14.851 6.33654 15.5581 5.62944C16.2652 4.92233 15.5581 4.21522 15.5581 4.21522L12.0225 0.679688L8.48701 4.21522C8.48701 4.21522 7.90122 5.04365 8.48701 5.62944C9.07279 6.21522 9.90122 5.62944 9.90122 5.62944ZM5.6519 14.1007L3.53058 11.9794L5.6519 9.85807C5.6519 9.85807 6.359 9.15097 5.6519 8.44386C4.94479 7.73675 4.23768 8.44386 4.23768 8.44386L0.702148 11.9794L4.23768 15.5149C4.23768 15.5149 5.06611 16.1007 5.6519 15.5149C6.23768 14.9291 5.6519 14.1007 5.6519 14.1007ZM14.1217 18.3264L12.0004 20.4478L9.87906 18.3264C9.87906 18.3264 9.17195 17.6193 8.46484 18.3264C7.75774 19.0336 8.46484 19.7407 8.46484 19.7407L12.0004 23.2762L15.5359 19.7407C15.5359 19.7407 16.1217 18.9122 15.5359 18.3264C14.9501 17.7407 14.1217 18.3264 14.1217 18.3264ZM20.5148 11.9779L18.3934 9.85657C18.3934 9.85657 17.8077 9.02814 18.3934 8.44236C18.9792 7.85657 19.8077 8.44236 19.8077 8.44236L23.3432 11.9779L19.8077 15.5134C19.8077 15.5134 19.1006 16.2205 18.3934 15.5134C17.6863 14.8063 18.3934 14.0992 18.3934 14.0992L20.5148 11.9779Z",
        fill: color
      }));

    case 'divide':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C11.4477 3 11 3.44772 11 4V5C11 5.55228 11.4477 6 12 6C12.5523 6 13 5.55228 13 5V4C13 3.44772 12.5523 3 12 3ZM12 8C11.4477 8 11 8.44772 11 9V10C11 10.5523 11.4477 11 12 11C12.5523 11 13 10.5523 13 10V9C13 8.44772 12.5523 8 12 8ZM11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V14ZM12 18C11.4477 18 11 18.4477 11 19V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V19C13 18.4477 12.5523 18 12 18Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        opacity: "0.3",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.0004 9.04C16.0004 8.62075 16.4854 8.38766 16.8127 8.64957L20.5123 11.6093C20.7626 11.8094 20.7625 12.19 20.5123 12.3901L16.8127 15.3498C16.4854 15.6117 16.0004 15.3786 16.0004 14.9594V9.04ZM8.00039 14.9594C8.00039 15.3786 7.51542 15.6117 7.18804 15.3498L3.48843 12.3901C3.23823 12.19 3.23823 11.8094 3.48843 11.6093L7.18804 8.64957C7.51542 8.38766 8.00039 8.62075 8.00039 9.04V14.9594Z",
        fill: color
      }));

    case 'union':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 3C3.44772 3 3 3.44772 3 4V5C3 5.55228 3.44772 6 4 6C4.55228 6 5 5.55228 5 5V4C5 3.44772 4.55228 3 4 3ZM4 8C3.44772 8 3 8.44772 3 9V10C3 10.5523 3.44772 11 4 11C4.55228 11 5 10.5523 5 10V9C5 8.44772 4.55228 8 4 8ZM3 14C3 13.4477 3.44772 13 4 13C4.55228 13 5 13.4477 5 14V15C5 15.5523 4.55228 16 4 16C3.44772 16 3 15.5523 3 15V14ZM4 18C3.44772 18 3 18.4477 3 19V20C3 20.5523 3.44772 21 4 21C4.55228 21 5 20.5523 5 20V19C5 18.4477 4.55228 18 4 18Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 3C19.4477 3 19 3.44772 19 4V5C19 5.55228 19.4477 6 20 6C20.5523 6 21 5.55228 21 5V4C21 3.44772 20.5523 3 20 3ZM20 8C19.4477 8 19 8.44772 19 9V10C19 10.5523 19.4477 11 20 11C20.5523 11 21 10.5523 21 10V9C21 8.44772 20.5523 8 20 8ZM19 14C19 13.4477 19.4477 13 20 13C20.5523 13 21 13.4477 21 14V15C21 15.5523 20.5523 16 20 16C19.4477 16 19 15.5523 19 15V14ZM20 18C19.4477 18 19 18.4477 19 19V20C19 20.5523 19.4477 21 20 21C20.5523 21 21 20.5523 21 20V19C21 18.4477 20.5523 18 20 18Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        opacity: "0.3",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.5 9.04C17.5 8.62075 17.015 8.38766 16.6877 8.64957L12.988 11.6093C12.7378 11.8094 12.7378 12.19 12.988 12.3901L16.6877 15.3498C17.015 15.6117 17.5 15.3786 17.5 14.9594V9.04ZM6.5 14.9594C6.5 15.3786 6.98497 15.6117 7.31235 15.3498L11.012 12.3901C11.2622 12.19 11.2622 11.8094 11.012 11.6093L7.31235 8.64957C6.98497 8.38766 6.5 8.62075 6.5 9.04V14.9594Z",
        fill: color
      }));

    case 'addText':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.125 7.2V19C13.125 19.5523 12.6773 20 12.125 20H10.875C10.3227 20 9.875 19.5523 9.875 19V7.2H6C5.44772 7.2 5 6.75228 5 6.2V5C5 4.44772 5.44772 4 6 4L17 4C17.5523 4 18 4.44772 18 5V6.2C18 6.75228 17.5523 7.2 17 7.2H13.125Z",
        fill: color
      }));

    case 'selectArea':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "21",
        height: "22",
        viewBox: "0 0 21 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        opacity: "0.3",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.125 0.25C1.50368 0.25 1 0.753679 1 1.375C1 1.99632 1.50368 2.5 2.125 2.5H3.625C4.24632 2.5 4.75 1.99632 4.75 1.375C4.75 0.753679 4.24632 0.25 3.625 0.25H2.125ZM2.125 19.25C1.50368 19.25 1 19.7537 1 20.375C1 20.9963 1.50368 21.5 2.125 21.5H3.625C4.24632 21.5 4.75 20.9963 4.75 20.375C4.75 19.7537 4.24632 19.25 3.625 19.25H2.125ZM6 1.375C6 0.753679 6.50368 0.25 7.125 0.25H8.625C9.24632 0.25 9.75 0.753679 9.75 1.375C9.75 1.99632 9.24632 2.5 8.625 2.5H7.125C6.50368 2.5 6 1.99632 6 1.375ZM7.125 19.25C6.50368 19.25 6 19.7537 6 20.375C6 20.9963 6.50368 21.5 7.125 21.5H8.625C9.24632 21.5 9.75 20.9963 9.75 20.375C9.75 19.7537 9.24632 19.25 8.625 19.25H7.125ZM11 1.375C11 0.753679 11.5037 0.25 12.125 0.25H13.625C14.2463 0.25 14.75 0.753679 14.75 1.375C14.75 1.99632 14.2463 2.5 13.625 2.5H12.125C11.5037 2.5 11 1.99632 11 1.375ZM12.125 19.25C11.5037 19.25 11 19.7537 11 20.375C11 20.9963 11.5037 21.5 12.125 21.5H13.625C14.2463 21.5 14.75 20.9963 14.75 20.375C14.75 19.7537 14.2463 19.25 13.625 19.25H12.125ZM16 1.375C16 0.753679 16.5037 0.25 17.125 0.25H18.625C19.2463 0.25 19.75 0.753679 19.75 1.375C19.75 1.99632 19.2463 2.5 18.625 2.5H17.125C16.5037 2.5 16 1.99632 16 1.375ZM17.125 19.25C16.5037 19.25 16 19.7537 16 20.375C16 20.9963 16.5037 21.5 17.125 21.5H18.625C19.2463 21.5 19.75 20.9963 19.75 20.375C19.75 19.7537 19.2463 19.25 18.625 19.25H17.125ZM19.125 7.75006C18.5037 7.75006 18 7.24638 18 6.62506V5.12506C18 4.50374 18.5037 4.00006 19.125 4.00006C19.7463 4.00006 20.25 4.50374 20.25 5.12506V6.62506C20.25 7.24638 19.7463 7.75006 19.125 7.75006ZM0 6.62506C0 7.24638 0.503679 7.75006 1.125 7.75006C1.74632 7.75006 2.25 7.24638 2.25 6.62506V5.12506C2.25 4.50374 1.74632 4.00006 1.125 4.00006C0.503679 4.00006 0 4.50374 0 5.12506V6.62506ZM19.125 12.7501C18.5037 12.7501 18 12.2464 18 11.6251V10.1251C18 9.50374 18.5037 9.00006 19.125 9.00006C19.7463 9.00006 20.25 9.50374 20.25 10.1251V11.6251C20.25 12.2464 19.7463 12.7501 19.125 12.7501ZM0 11.6251C0 12.2464 0.503679 12.7501 1.125 12.7501C1.74632 12.7501 2.25 12.2464 2.25 11.6251V10.1251C2.25 9.50374 1.74632 9.00006 1.125 9.00006C0.503679 9.00006 0 9.50374 0 10.1251V11.6251ZM19.125 17.7501C18.5037 17.7501 18 17.2464 18 16.6251V15.1251C18 14.5037 18.5037 14.0001 19.125 14.0001C19.7463 14.0001 20.25 14.5037 20.25 15.1251V16.6251C20.25 17.2464 19.7463 17.7501 19.125 17.7501ZM0 16.6251C0 17.2464 0.503679 17.7501 1.125 17.7501C1.74632 17.7501 2.25 17.2464 2.25 16.6251V15.1251C2.25 14.5037 1.74632 14.0001 1.125 14.0001C0.503679 14.0001 0 14.5037 0 15.1251V16.6251Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.25 10.75C6.25 12.8211 7.92893 14.5 10 14.5C12.0711 14.5 13.75 12.8211 13.75 10.75C13.75 8.67893 12.0711 7 10 7C7.92893 7 6.25 8.67893 6.25 10.75ZM12.2498 10.7499C12.2498 11.9926 11.2424 12.9999 9.99977 12.9999C8.75713 12.9999 7.74977 11.9926 7.74977 10.7499C7.74977 9.5073 8.75713 8.49994 9.99977 8.49994C11.2424 8.49994 12.2498 9.5073 12.2498 10.7499Z",
        fill: color
      }));

    case 'wkt':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "46",
        height: "24",
        viewBox: "0 0 46 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("rect", {
        x: "3",
        y: "3",
        width: "40",
        height: "18",
        rx: "2",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        stroke: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16.2695 14.082L17.5883 7H19.6002L17.4268 16.9531H15.3948L13.8001 10.2949L12.2054 16.9531H10.1734L8 7H10.0119L11.3374 14.0684L12.9523 7H14.6614L16.2695 14.082Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M24.3558 12.9609L23.3062 14.1094V16.9531H21.2876V7H23.3062V11.5117L24.1943 10.2744L26.6907 7H29.1735L25.6948 11.4229L29.2745 16.9531H26.8723L24.3558 12.9609Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M38 8.66113H34.999V16.9531H32.9804V8.66113H30.0198V7H38V8.66113Z",
        fill: color
      }));

    case 'sun':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.49996 10.499C0.671556 10.499 0 11.1706 0 11.999C0 12.8274 0.671555 13.4989 1.49996 13.4989H3.49997C4.32838 13.4989 4.99993 12.8274 4.99993 11.999C4.99993 11.1706 4.32838 10.499 3.49997 10.499H1.49996ZM20.5 10.499C19.6716 10.499 19.0001 11.1706 19.0001 11.999C19.0001 12.8274 19.6716 13.4989 20.5 13.4989H22.5C23.3284 13.4989 24 12.8274 24 11.999C24 11.1706 23.3284 10.499 22.5 10.499H20.5Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.9498 4.9283C16.364 5.51407 16.364 6.46379 16.9498 7.04956C17.5356 7.63534 18.4853 7.63534 19.0711 7.04957L20.4853 5.63539C21.0711 5.04961 21.0711 4.09989 20.4853 3.51412C19.8995 2.92835 18.9498 2.92835 18.364 3.51412L16.9498 4.9283ZM3.51496 18.3634C2.92918 18.9492 2.92918 19.8989 3.51496 20.4847C4.10074 21.0704 5.05047 21.0704 5.63625 20.4847L7.05045 19.0705C7.63623 18.4847 7.63623 17.535 7.05045 16.9492C6.46467 16.3635 5.51493 16.3635 4.92916 16.9492L3.51496 18.3634Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5 22.499C10.5 23.3275 11.1716 23.999 12 23.999C12.8284 23.999 13.5 23.3275 13.5 22.499V20.4991C13.5 19.6707 12.8284 18.9991 12 18.9991C11.1716 18.9991 10.5 19.6707 10.5 20.4991V22.499ZM10.5 3.49927C10.5 4.32768 11.1716 4.99925 12 4.99925C12.8284 4.99925 13.5 4.32768 13.5 3.49927V1.49935C13.5 0.670933 12.8284 -0.000629425 12 -0.000629425C11.1716 -0.000629425 10.5 0.670933 10.5 1.49935V3.49927Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.3639 20.4848C18.9497 21.0705 19.8994 21.0705 20.4852 20.4848C21.071 19.899 21.071 18.9493 20.4852 18.3635L19.071 16.9493C18.4852 16.3636 17.5355 16.3636 16.9497 16.9493C16.3639 17.5351 16.3639 18.4848 16.9497 19.0706L18.3639 20.4848ZM4.92881 7.04967C5.51458 7.63544 6.46432 7.63544 7.0501 7.04967C7.63587 6.46389 7.63587 5.51417 7.0501 4.9284L5.6359 3.51422C5.05012 2.92845 4.10039 2.92845 3.51461 3.51422C2.92883 4.09999 2.92883 5.04971 3.51461 5.63549L4.92881 7.04967Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.00024 12.4989C7.00024 15.2603 9.23879 17.4988 12.0002 17.4988C14.7616 17.4988 17.0001 15.2603 17.0001 12.4989C17.0001 9.73754 14.7616 7.49902 12.0002 7.49902C9.23879 7.49902 7.00024 9.73754 7.00024 12.4989ZM14.9999 12.4989C14.9999 14.1557 13.6567 15.4989 11.9999 15.4989C10.3431 15.4989 8.99994 14.1557 8.99994 12.4989C8.99994 10.8421 10.3431 9.499 11.9999 9.499C13.6567 9.499 14.9999 10.8421 14.9999 12.4989Z",
        fill: color
      }));

    case 'rain':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M6 13.8028C6 15.9611 4.8 17.3999 3 17.3999C1.2 17.3999 -2.38419e-07 15.6014 -2.38419e-07 13.8028C-2.38419e-07 12.6841 0.870535 11.1478 2.61161 9.19406C2.83384 8.94468 3.1766 8.93433 3.40902 9.16998C5.13634 10.9214 6 12.4656 6 13.8028Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M24 16.7202C24 21.0881 21.6 24 18 24C14.4 24 12 20.3601 12 16.7202C12 14.4561 13.7411 11.347 17.2232 7.39293C17.6677 6.88823 18.3532 6.86729 18.818 7.34421C22.2727 10.8887 24 14.014 24 16.7202Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M13 4.8028C13 6.96106 11.8 8.3999 10 8.3999C8.2 8.3999 7 6.60135 7 4.8028C7 3.68407 7.87053 2.14783 9.61161 0.194058C9.83384 -0.055324 10.1766 -0.0656717 10.409 0.169982C12.1363 1.92137 13 3.46564 13 4.8028Z",
        fill: color
      }));

    case 'gear':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.5 9.5C0.671573 9.5 0 10.1716 0 11V13.2C0 14.0284 0.671571 14.7 1.5 14.7H3.49993C4.32836 14.7 4.99993 14.0284 4.99993 13.2V11C4.99993 10.1716 4.32836 9.5 3.49993 9.5H1.5ZM20.5001 9.5C19.6716 9.5 19.0001 10.1716 19.0001 11V13.2C19.0001 14.0284 19.6716 14.7 20.5001 14.7H22.5C23.3284 14.7 24 14.0284 24 13.2V11C24 10.1716 23.3284 9.5 22.5 9.5H20.5001Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.73693 17.6859C2.15114 18.2717 2.15114 19.2215 2.73693 19.8072L4.29256 21.3629C4.87835 21.9487 5.8281 21.9487 6.41388 21.3629L7.82805 19.9487C8.41384 19.3629 8.41384 18.4132 7.82805 17.8274L6.27242 16.2718C5.68663 15.686 4.73688 15.686 4.1511 16.2718L2.73693 17.6859ZM16.172 4.25085C15.5862 4.83664 15.5862 5.78639 16.172 6.37217L17.7276 7.92781C18.3134 8.51359 19.2632 8.5136 19.849 7.92781L21.2631 6.51364C21.8489 5.92786 21.8489 4.97811 21.2631 4.39232L19.7075 2.83669C19.1217 2.2509 18.172 2.2509 17.5862 2.83669L16.172 4.25085Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.5861 21.3627C18.1719 21.9485 19.1216 21.9485 19.7074 21.3627L21.263 19.807C21.8488 19.2213 21.8488 18.2715 21.263 17.6857L19.8489 16.2716C19.2631 15.6858 18.3133 15.6858 17.7275 16.2716L16.1719 17.8272C15.5861 18.413 15.5861 19.3627 16.1719 19.9485L17.5861 21.3627ZM4.151 7.92761C4.73679 8.5134 5.68653 8.5134 6.27232 7.92761L7.82795 6.37198C8.41374 5.78619 8.41374 4.83644 7.82796 4.25066L6.41379 2.83649C5.828 2.2507 4.87825 2.2507 4.29247 2.83649L2.73683 4.39213C2.15105 4.97791 2.15105 5.92766 2.73683 6.51344L4.151 7.92761Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.5 22.5005C9.5 23.3289 10.1716 24.0005 11 24.0005H13.2C14.0284 24.0005 14.7 23.3289 14.7 22.5005V20.5006C14.7 19.6722 14.0284 19.0006 13.2 19.0006H11C10.1716 19.0006 9.5 19.6722 9.5 20.5006V22.5005ZM9.5 3.50049C9.5 4.32891 10.1716 5.00049 11 5.00049H13.2C14.0284 5.00049 14.7 4.32892 14.7 3.50049L14.7 1.50061C14.7 0.672184 14.0284 0.000612259 13.2 0.000612259H11C10.1716 0.000612259 9.5 0.672184 9.5 1.50061V3.50049Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12.0004C3 16.9709 7.02944 21.0003 12 21.0003C16.9706 21.0003 21 16.9709 21 12.0004C21 7.02988 16.9706 3.00049 12 3.00049C7.02944 3.00049 3 7.02988 3 12.0004ZM16 12.0004C16 14.2096 14.2091 16.0004 12 16.0004C9.79086 16.0004 8 14.2096 8 12.0004C8 9.79133 9.79086 8.00049 12 8.00049C14.2091 8.00049 16 9.79133 16 12.0004Z",
        fill: color
      }));

    case 'question':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5909 13.209V14.868H11.8509C14.3919 14.868 16.3869 12.915 16.3869 10.395C16.3869 7.875 14.3919 5.922 11.8509 5.922C9.30994 5.922 7.33594 7.875 7.33594 10.395H9.12094C9.12094 8.799 10.2339 7.581 11.8509 7.581C13.4469 7.581 14.6019 8.799 14.6019 10.395C14.6019 11.991 13.4469 13.209 11.8509 13.209H10.5909ZM11.9999 16C11.4477 16 10.9999 16.4477 10.9999 17C10.9999 17.5523 11.4477 18 11.9999 18C12.5522 18 12.9999 17.5523 12.9999 17C12.9999 16.4477 12.5522 16 11.9999 16Z",
        fill: "white"
      }));

    case 'waterQuality':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.718 13.685C16.718 19.574 13.482 23.501 8.628 23.501 3.774 23.501.538 18.593.538 13.685.538 10.632 2.885 6.44 7.58 1.109 8.18.428 9.104.4 9.731 1.043 14.389 5.822 16.718 10.036 16.718 13.685Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "18",
        cy: "18",
        r: "6",
        fill: color,
        stroke: "white",
        strokeWidth: "2"
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.832 17.454C15.467 17.116 14.898 17.138 14.56 17.503 14.223 17.867 14.245 18.437 14.609 18.774L15.832 17.454ZM17.341 20.077 16.73 20.737C16.911 20.905 17.153 20.991 17.399 20.975 17.645 20.959 17.874 20.843 18.032 20.654L17.341 20.077ZM21.31 16.728C21.628 16.346 21.577 15.779 21.195 15.46 20.814 15.142 20.247 15.193 19.928 15.574L21.31 16.728ZM14.609 18.774 16.73 20.737 17.952 19.417 15.832 17.454 14.609 18.774ZM18.032 20.654 21.31 16.728 19.928 15.574 16.651 19.5 18.032 20.654Z",
        fill: "white"
      }));

    case 'priorityHighest':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.64645 2.31564C7.84171 2.14479 8.15829 2.14479 8.35355 2.31564L14.3536 7.56564C14.5488 7.7365 14.5488 8.0135 14.3536 8.18436C14.1583 8.35521 13.8417 8.35521 13.6464 8.18436L8 3.24372L2.35355 8.18436C2.15829 8.35521 1.84171 8.35521 1.64645 8.18436C1.45118 8.0135 1.45118 7.7365 1.64645 7.56564L7.64645 2.31564Z",
        fill: color,
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.64645 9.31564C7.84171 9.14479 8.15829 9.14479 8.35355 9.31564L14.3536 14.5656C14.5488 14.7365 14.5488 15.0135 14.3536 15.1844C14.1583 15.3552 13.8417 15.3552 13.6464 15.1844L8 10.2437L2.35355 15.1844C2.15829 15.3552 1.84171 15.3552 1.64645 15.1844C1.45118 15.0135 1.45118 14.7365 1.64645 14.5656L7.64645 9.31564Z",
        fill: color,
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case 'priorityHigh':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.64645 4.64645C7.84171 4.45118 8.15829 4.45118 8.35355 4.64645L14.3536 10.6464C14.5488 10.8417 14.5488 11.1583 14.3536 11.3536C14.1583 11.5488 13.8417 11.5488 13.6464 11.3536L8 5.70711L2.35355 11.3536C2.15829 11.5488 1.84171 11.5488 1.64645 11.3536C1.45118 11.1583 1.45118 10.8417 1.64645 10.6464L7.64645 4.64645Z",
        fill: color,
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case 'priorityNormal':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 5.5C1 5.22386 1.22386 5 1.5 5L14.5 5C14.7761 5 15 5.22386 15 5.5C15 5.77614 14.7761 6 14.5 6L1.5 6C1.22386 6 1 5.77614 1 5.5Z",
        fill: color,
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 10.5C1 10.2239 1.22386 10 1.5 10L14.5 10C14.7761 10 15 10.2239 15 10.5C15 10.7761 14.7761 11 14.5 11L1.5 11C1.22386 11 1 10.7761 1 10.5Z",
        fill: color,
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case 'priorityLow':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.64645 4.64645C1.84171 4.45118 2.15829 4.45118 2.35355 4.64645L8 10.2929L13.6464 4.64645C13.8417 4.45118 14.1583 4.45118 14.3536 4.64645C14.5488 4.84171 14.5488 5.15829 14.3536 5.35355L8.35355 11.3536C8.15829 11.5488 7.84171 11.5488 7.64645 11.3536L1.64645 5.35355C1.45118 5.15829 1.45118 4.84171 1.64645 4.64645Z",
        fill: color,
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case 'priorityLowest':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.64645 9.31564C1.84171 9.14479 2.15829 9.14479 2.35355 9.31564L8 14.2563L13.6464 9.31564C13.8417 9.14479 14.1583 9.14479 14.3536 9.31564C14.5488 9.4865 14.5488 9.7635 14.3536 9.93436L8.35355 15.1844C8.15829 15.3552 7.84171 15.3552 7.64645 15.1844L1.64645 9.93436C1.45118 9.7635 1.45118 9.4865 1.64645 9.31564Z",
        fill: color,
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.64645 2.31564C1.84171 2.14479 2.15829 2.14479 2.35355 2.31564L8 7.25628L13.6464 2.31564C13.8417 2.14479 14.1583 2.14479 14.3536 2.31564C14.5488 2.4865 14.5488 2.7635 14.3536 2.93436L8.35355 8.18436C8.15829 8.35521 7.84171 8.35521 7.64645 8.18436L1.64645 2.93436C1.45118 2.7635 1.45118 2.4865 1.64645 2.31564Z",
        fill: color,
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));

    case 'downloadMap':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.1475 1.33519C15.9759 1.33518 16.6475 2.00675 16.6475 2.83519L16.6474 14.7832C16.6474 15.1861 16.4853 15.5721 16.1977 15.8542L13.6817 18.3211C13.1048 18.8868 12.1834 18.8938 11.5978 18.337L9.11374 15.9744C8.81597 15.6912 8.64743 15.2983 8.64745 14.8875L8.64743 2.83522C8.64743 2.00678 9.31905 1.33518 10.1474 1.33524L15.1475 1.33519Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        opacity: "0.3",
        d: "M19 20H6C5.44772 20 5 20.4477 5 21C5 21.5523 5.44772 22 6 22H19C19.5523 22 20 21.5523 20 21C20 20.4477 19.5523 20 19 20Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M13.2035 19.3038C12.8138 19.6894 12.1862 19.6894 11.7965 19.3038L5.13521 12.7107C4.50023 12.0823 4.94527 11 5.83866 11L19.1613 11C20.0547 11 20.4998 12.0823 19.8648 12.7107L13.2035 19.3038Z",
        fill: color
      }));

    case 'uploadMap':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        opacity: "0.3",
        d: "M19 20H6C5.44772 20 5 20.4477 5 21C5 21.5523 5.44772 22 6 22H19C19.5523 22 20 21.5523 20 21C20 20.4477 19.5523 20 19 20Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10.0952 18.8787C9.26678 18.8787 8.59521 18.2071 8.59521 17.3787L8.59523 5.43071C8.59523 5.0278 8.75737 4.64179 9.04502 4.35966L11.5609 1.89281C12.1379 1.32704 13.0593 1.32004 13.6448 1.87691L16.1289 4.23947C16.4267 4.52267 16.5952 4.91556 16.5952 5.32641L16.5952 17.3786C16.5952 18.2071 15.9236 18.8787 15.0953 18.8786L10.0952 18.8787Z",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12.0392 0.910105C12.4289 0.524428 13.0565 0.524428 13.4461 0.910105L20.1075 7.50312C20.7424 8.13158 20.2974 9.21387 19.404 9.21387L6.08133 9.21387C5.18794 9.21387 4.74291 8.13158 5.37788 7.50312L12.0392 0.910105Z",
        fill: color
      }));

    case 'landscape':
      return /*#__PURE__*/_react.default.createElement("svg", _extends({
        className: classNames,
        style: styles,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, rest), /*#__PURE__*/_react.default.createElement("path", {
        d: "M 2.949219 2.949219 L 2.949219 21.050781 L 21.050781 21.050781 L 21.050781 2.949219 Z M 3 3 L 21 3 L 21 15.257812 L 17.582031 11.839844 C 16.996094 11.257812 16.046875 11.257812 15.460938 11.839844 L 6.300781 21 L 3 21 Z M 3 3",
        fill: color
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M 11.1875 9.050781 C 11.1875 7.394531 9.84375 6.050781 8.1875 6.050781 C 6.53125 6.050781 5.1875 7.394531 5.1875 9.050781 C 5.1875 10.707031 6.53125 12.050781 8.1875 12.050781 C 9.84375 12.050781 11.1875 10.707031 11.1875 9.050781 Z M 11.1875 9.050781",
        fill: color
      }));


    default:
      return /*#__PURE__*/_react.default.createElement("span", null);
  }
}

Icon.propTypes = {
  /** Type of icon */
  icon: _propTypes.default.oneOf(['arrowDown', 'arrowLeft', 'arrowRight', 'arrowUp', 'arrowUpRight', 'bell', 'calendar', 'close', 'delete', 'downLeft', 'downloadFile', 'earth', 'edit', 'filePlus', 'files', 'filters', 'inProgress', 'layers', 'loading', 'map', 'menu', 'minus', 'notification', 'pencil', 'plus', 'position', 'register', 'renewed', 'reset', 'ruler', 'search', 'sort', 'sortAsc', 'sortDesc', 'tick', 'times', 'user', 'add', 'drawPoint', 'drawLineString', 'drawPolygon', 'drag', 'modify', 'divide', 'union', 'addText', 'selectArea', 'wkt', 'sun', 'rain', 'gear', 'question', 'waterQuality', 'priorityHighest', 'priorityHigh', 'priorityNormal', 'priorityLow', 'priorityLowest', 'downloadMap', 'uploadMap', 'landscape']).isRequired,

  /** Color of an icon */
  color: _propTypes.default.node,

  /** Margins */
  margin: _propTypes.default.string,

  /** Height and width of icon */
  size: _propTypes.default.string,

  /** Width of icon */
  width: _propTypes.default.string,

  /** Height of icon */
  height: _propTypes.default.string
};
Icon.defaultProps = {
  color: _Colors.default.vagaVesi,
  size: '24px'
};
var _default = Icon;
exports.default = _default;